/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Follow_DeclineInputs */

const en_follow_decline = /** @type {(inputs: Follow_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decline`)
};

const es_follow_decline = /** @type {(inputs: Follow_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechazar`)
};

const fr_follow_decline = /** @type {(inputs: Follow_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refuser`)
};

const de_follow_decline = /** @type {(inputs: Follow_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ablehnen`)
};

const id_follow_decline = /** @type {(inputs: Follow_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolak`)
};

/** @type {(inputs: Follow_DeclineInputs) => LocalizedString} */
const ja_follow_decline = en_follow_decline;

/** @type {(inputs: Follow_DeclineInputs) => LocalizedString} */
const zh_follow_decline = en_follow_decline;

/** @type {(inputs: Follow_DeclineInputs) => LocalizedString} */
const ar_follow_decline = en_follow_decline;

/** @type {(inputs: Follow_DeclineInputs) => LocalizedString} */
const it_follow_decline = en_follow_decline;

/** @type {(inputs: Follow_DeclineInputs) => LocalizedString} */
const ru_follow_decline = en_follow_decline;

/** @type {(inputs: Follow_DeclineInputs) => LocalizedString} */
const pt_follow_decline = en_follow_decline;

/** @type {(inputs: Follow_DeclineInputs) => LocalizedString} */
const ko_follow_decline = en_follow_decline;

/**
* | output |
* | --- |
* | "Decline" |
*
* @param {Follow_DeclineInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const follow_decline = /** @type {((inputs?: Follow_DeclineInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_DeclineInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_follow_decline(inputs)
	if (locale === "es") return es_follow_decline(inputs)
	if (locale === "fr") return fr_follow_decline(inputs)
	if (locale === "de") return de_follow_decline(inputs)
	if (locale === "ja") return ja_follow_decline(inputs)
	if (locale === "zh") return zh_follow_decline(inputs)
	if (locale === "ar") return ar_follow_decline(inputs)
	if (locale === "id") return id_follow_decline(inputs)
	if (locale === "it") return it_follow_decline(inputs)
	if (locale === "ru") return ru_follow_decline(inputs)
	if (locale === "pt") return pt_follow_decline(inputs)
	return ko_follow_decline(inputs)
});